import { CommonModule } from "@angular/common";
import { inject, NgModule } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { PipesModule } from "src/app/pipes/pipes.module";
import { ProvideMemberAuthComponent } from "src/app/services/member-auth-provider/components/provide-member-auth.component";
import { MemberAuthProviderService } from "src/app/services/member-auth-provider/member-auth-provider.service";
import { MemberAuthProviderDefaultService } from "src/app/services/member-auth-provider/providers/member-auth-provider-default.service";
import { MemberAuthProviderPlatformService } from "src/app/services/member-auth-provider/providers/member-auth-provider-platform.service";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";

@NgModule({
  imports: [CommonModule, TranslocoModule, PipesModule],
  providers: [
    MemberAuthProviderDefaultService,
    MemberAuthProviderPlatformService,
    {
      provide: MemberAuthProviderService,
      useFactory: () => {
        switch (inject(ProductService).getCurrentProduct()) {
          case SoftwareProduct.PMS:
          case SoftwareProduct.ROCKET:
          case SoftwareProduct.SNOOTS:
          case SoftwareProduct.ADMIN: {
            return inject(MemberAuthProviderDefaultService);
          }
          case SoftwareProduct.DROP_PAGE:
          case SoftwareProduct.PLATFORM:
          case SoftwareProduct.BOTMASTER: {
            return inject(MemberAuthProviderPlatformService);
          }
        }
      }
    }
  ],
  declarations: [ProvideMemberAuthComponent]
})
export class MemberAuthProviderModule {}
